export const isGlobalCheck = (pathname: string): boolean => {
  let isglobalUrl = false;
  const splitPathname = pathname.split('/');
  if (splitPathname[1] === 'global') {
    isglobalUrl = true;
  }
  return isglobalUrl;
};
